/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.ApiResponse,
  EditScheduledFund: (params: vp.EditScheduledFundRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostEditScheduledFund: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldEditScheduledFund, setShouldEditScheduledFund] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.EditScheduledFundRequest>({
    ScheduledTransactionID: '',
    UpcomingPayment: '',
    Amount: '',
    NewDate: '',
  });
  const [response, setResponse] = useState<vp.ApiResponse>({
    Success: false,
    ErrorMessage: '',
  });

  useEffect(() => {
    if (!shouldEditScheduledFund) return () => {};

    const PostEditScheduledFund = async () => {
      setDataFetchingInfo(true, 'Loading', 'fullScreen');
      const res = await api.postEditScheduledFund(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldEditScheduledFund) void PostEditScheduledFund();
    setShouldEditScheduledFund(false);
    return () => {
      source.cancel();
    };
  }, [shouldEditScheduledFund]);

  return [
    response,
    (_params: vp.EditScheduledFundRequest) => {
      setParams(_params);
      setShouldEditScheduledFund(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setShouldEditScheduledFund(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostEditScheduledFund);
